import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import 'react-datepicker/dist/react-datepicker.css'
import 'theme/reset.scss'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from 'app'
import AlertTemplate from 'react-alert-template-basic'
import reportWebVitals from './reportWebVitals'
import { SnackbarProvider } from 'notistack'
import { App as AntApp, ConfigProvider } from 'antd'
import { BrowserRouter } from 'react-router-dom'
// import * as serviceWorker from './serviceWorker.js';

const options = {
  // you can also just use 'bottom center'
  position: positions.TOP_RIGHT,
  timeout: 2000,
  offset: '30px',
  // you can also just use 'scale'
  transition: transitions.SCALE,
  containerStyle: {
    zIndex: 9000,
  },
}

// Create a root instance
const root = createRoot(document.getElementById('root'));

// Render your app using the root
root.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#df7467',
        colorInfo: '#df7467',
        fontFamily: 'Source Sans Pro',
      },
      components: {
        Table: {
          rowSelectedBg: '#FFFFFF',
          rowSelectedHoverBg: '#f5f5f5',
        },
        Select: {
          multipleItemBg: '#fff4f0',
        },
      },
    }}
  >
    <AntApp>
      <BrowserRouter>
        <AlertProvider template={AlertTemplate} {...options}>
          <React.StrictMode>
            <SnackbarProvider autoHideDuration={null}>
              <App />
            </SnackbarProvider>
          </React.StrictMode>
        </AlertProvider>
      </BrowserRouter>
    </AntApp>
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
// serviceWorker.unregister();